import vueAnimateNumber from "./src/vue3-animate-number";
// 为组件提供 install 安装方法，供按需引入
vueAnimateNumber.install = function (Vue) {
  Vue.component("vueAnimateNumber", vueAnimateNumber);
};
export default vueAnimateNumber;
